export default __webpack_public_path__ + "static/media/Maestro_Logo.40dab75e.svg";